export default "__VITE_ASSET__kBJxBg$H__"